import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import './myralis/tokens.css';
import './myralis/theme.css';
import './myralis/surfaceThemeFix';
import './myralis/loginCardFix';
import './myralis/techdocsShadowTheme';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
